import { useEffect, useState, useRef } from 'react';
import { API_URL } from '../../shared/constant';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from "react-date-picker";
import LoaderComponent from '../../shared/loader';
import Swal from "sweetalert2";

export default function PartyPaymentLedger() {
    const [isLoading, setLoading] = useState(false);
    const [partyId, setPartyId] = useState(0);
    const [data, setData] = useState([]);
    const [summary, setSummary] = useState(null);
    const [partyData, setPartyData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [partyError, setPartyError] = useState(false);
    const selectRef = useRef();

    useEffect(() => {
        getParty();
    }, []);

    const getParty = () => {
        setLoading(true);
        axios.post(API_URL.PARTY_LIST, { is_seller: [0, 1] }).then(res => {
            let pt = res.data.data.map((row) => {
                return {
                    value: row.id,
                    label: row.name + " - " + row.contact_no
                }
            })
            setPartyData(pt);
            setLoading(false);
        }, error => {
            setLoading(false);
            toast.error("Failed to load parties", {
                autoClose: 3000,
            });
        })
    };

    const fetchLedgerData = (party_id, from_date, to_date) => {
        if (!party_id || party_id === 0) {
            setPartyError(true);
            toast.error("Please select a party", {
                autoClose: 3000,
            });
            return;
        }

        setPartyError(false);
        setLoading(true);
        let params = {
            party_id: party_id,
            from_date: (from_date) ? moment(from_date).format("YYYY-MM-DD") : null,
            to_date: (to_date) ? moment(to_date).format("YYYY-MM-DD") : null,
        }
        axios.post(API_URL.LEDGER_LIST, params).then(res => {
            if (res.data.status === 1) {
                setData(res.data.data || []);
                setSummary(res.data.summary || null);
            } else {
                setData([]);
                setSummary(null);
                toast.error(res.data.message || "No data found", {
                    autoClose: 3000,
                });
            }
            setLoading(false);
        }, error => {
            setLoading(false);
            setData([]);
            setSummary(null);
            toast.error("Something went wrong..", {
                autoClose: 3000,
            });
        })
    };

    const changeParty = (party_id, from_date, to_date) => {
        setPartyId(party_id);
        if (party_id && party_id > 0) {
            fetchLedgerData(party_id, from_date, to_date);
        } else {
            setData([]);
            setSummary(null);
        }
    };

    const searchDataByDate = (fromDate, toDate) => {
        if (partyId && partyId > 0) {
            fetchLedgerData(partyId, fromDate, toDate);
        }
    };

    const clearFilter = () => {
        setStartDate(null);
        setEndDate(null);
        setData([]);
        setSummary(null);
        setPartyId(0);
        setPartyError(false);
        setTimeout(() => {
            selectRef.current.clearValue();
        }, 200);
    };

    const deleteData = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this payment - " + (row.description || ''),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(API_URL.PAYMENT_DELETE, { id: row.payment_id }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            fetchLedgerData(partyId, startDate, endDate);
                            toast.success("Delete Successfully", { autoClose: 3000 });
                        } else {
                            toast.error(res.data.data || "Failed to delete", { autoClose: 3000 });
                        }
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        toast.error("Something went wrong..", {
                            autoClose: 3000,
                            position: "top-right",
                        });
                    }
                );
            }
        });
    };

    return (
        <div>
            <div className='card payments'>
                <div className='d-flex card-header'>
                    <span className='pt-1 d-inline-block'>Party Payment Ledger</span>
                </div>
                <div className='card-body'>
                    <div className="fz14">
                        <div className='row mb-3'>
                            <div className='col-md-3 mb-3 col-sm-12'>
                                <div className={`form-group ${partyError ? 'error1' : ''}`}>
                                    <label>Party <span className="required-text">*</span></label>
                                    <Select 
                                        ref={selectRef} 
                                        placeholder={'Select Party'} 
                                        value={partyData.find(pt => pt.value == partyId)} 
                                        options={partyData} 
                                        onChange={(e) => changeParty((e ? e.value : 0), startDate, endDate)} 
                                    />
                                    {partyError && <span className="text-danger small">Party is required</span>}
                                </div>
                            </div>
                            <div className='col-md-3 mb-3 col-sm-12'>
                                <div className="form-group">
                                    <label>From Date</label>
                                    <DatePicker
                                        placeholderText="From Date"
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control input-sm"
                                        selected={startDate}
                                        onChange={(date) => [setStartDate(date), searchDataByDate(date, endDate)]}
                                        value={startDate}
                                    />
                                </div>
                            </div>
                            <div className='col-md-3 mb-3 col-sm-12'>
                                <div className="form-group">
                                    <label>To Date</label>
                                    <DatePicker
                                        placeholderText="To Date"
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control input-sm"
                                        selected={endDate}
                                        onChange={(date) => [setEndDate(date), searchDataByDate(startDate, date)]}
                                        value={endDate}
                                    />
                                </div>
                            </div>
                            <div className='col-md-3 col-sm-12 text-left'>
                                {(partyId || startDate || endDate) && (
                                    <button 
                                        type='button' 
                                        className='btn btn-danger mr-2' 
                                        onClick={clearFilter}
                                        style={{ marginTop: '30px' }}
                                    >
                                        Clear Filter
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {summary && (
                <div className='card payments mt-3'>
                    <div className='card-header'>
                        <span className='pt-1 d-inline-block'>Summary</span>
                    </div>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-md-3'>
                                <strong>Party:</strong> {summary.party_name}
                            </div>
                            <div className='col-md-3'>
                                <strong>Total Debit:</strong> {summary.total_debit}
                            </div>
                            <div className='col-md-3'>
                                <strong>Total Credit:</strong> {summary.total_credit}
                            </div>
                            <div className='col-md-3'>
                                <strong>Final Outstanding:</strong> {summary.final_outstanding}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {data.length > 0 && (
                <div className='card payments mt-3'>
                    <div className='card-header'>
                        <span className='pt-1 d-inline-block'>Ledger Details</span>
                    </div>
                    <div className='card-body'>
                        <div className="table-responsive">
                            <table className="table table-center table-hover datatable">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="index-th">#</th>
                                        <th>Date</th>
                                        <th>Payment View</th>
                                        <th>Payment Mode</th>
                                        <th>Payment Type</th>
                                        <th>Invoice No</th>
                                        <th>Description</th>
                                        <th>Remark</th>
                                        <th>Amount</th>
                                        <th>Debit</th>
                                        <th>Credit</th>
                                        <th>Outstanding Balance</th>
                                        <th className="action-th">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row, key) => (
                                        <tr key={key}>
                                            <td className="index-td">{key + 1}</td>
                                            <td>{row.date_formatted || moment(row.date).format("DD/MM/YYYY")}</td>
                                            <td>{row.payment_view || '-'}</td>
                                            <td>{row.payment_mode || '-'}</td>
                                            <td>{row.payment_type || '-'}</td>
                                            <td>{row.invoice_no || '-'}</td>
                                            <td>{row.description || '-'}</td>
                                            <td>{row.remark || '-'}</td>
                                            <td>{row.amount || '0.00'}</td>
                                            <td>{row.debit || '0.00'}</td>
                                            <td>{row.credit || '0.00'}</td>
                                            <td>{row.outstanding_balance || '0.00'}</td>
                                            <td className="action-td">
                                                {row.payment_view === "Direct" && (
                                                    <>
                                                        <Link to={"/payments/edit/" + row.payment_id}>
                                                            <button className="btn btn-sm btn-primary mr-2">
                                                                <i className="fa fa-edit me-1"></i> Edit
                                                            </button>
                                                        </Link>
                                                        <button
                                                            onClick={() => deleteData(row)}
                                                            className="btn btn-sm btn-danger me-2"
                                                        >
                                                            <i className="fa fa-trash me-1"></i> Delete
                                                        </button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {isLoading && <LoaderComponent mode='full' height={100} width={100}></LoaderComponent>}
        </div>
    )
}

